import React, {
  forwardRef,
  useImperativeHandle,
  useState
} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import config from "../../../config";

const AddSubjectModal = forwardRef(
  ({ classes, refreshSubjects }, ref) => {

    const [show, setShow] = useState(false);

    const [gradeId, setGradeId] = useState("");
    const [subjectName, setSubjectName] = useState("");
    const [subjectCode, setSubjectCode] = useState("");

    /* ---------------------------------------
       Unique Grades
    --------------------------------------- */
    const uniqueGrades = [
      ...new Map(classes.map(c => [c.grade_id, c])).values()
    ];

    /* ---------------------------------------
       Sections for selected grade
    --------------------------------------- */
    const sectionsForGrade = gradeId
      ? classes.filter(c => c.grade_id == gradeId)
      : [];

      console.log(sectionsForGrade);
    /* ---------------------------------------
       Expose openModal
    --------------------------------------- */
    useImperativeHandle(ref, () => ({
      openModal() {
        setShow(true);
      }
    }));

    const closeModal = () => {
      setShow(false);
      setGradeId("");
      setSubjectName("");
      setSubjectCode("");
    };

    /* ---------------------------------------
       Fetch next code (use first section)
    --------------------------------------- */
    const fetchNextCode = async (clsId) => {
      const res = await axios.get(
        `${config.apiBaseUrl}/academic/get-next-subject-code.php`,
        { params: { class_id: clsId } }
      );

      if (res.data.success) {
        setSubjectCode(res.data.next_code);
      }
    };

    const handleGradeChange = (value) => {
      setGradeId(value);
      setSubjectCode("");

      const firstClass = classes.find(c => c.grade_id == value);
      if (firstClass) {
        fetchNextCode(firstClass.class_id);
      }
    };

    /* ---------------------------------------
       Submit (Create for ALL sections)
    --------------------------------------- */
    const handleSubmit = async (e) => {
      e.preventDefault();

      if (!gradeId) {
        Swal.fire("Error", "Select class", "warning");
        return;
      }

      try {
        const classIds = sectionsForGrade.map(c => c.class_id);

        const res = await axios.post(
          `${config.apiBaseUrl}/subject/add-subject.php`,
          {
            subject_name: subjectName,
            subject_code: subjectCode,
            grade_id: gradeId    // ✅ SEND THIS
          }
        );

        if (res.data.success) {
          Swal.fire("Success", "Subject created for all sections", "success");
          refreshSubjects();
          closeModal();
        } else {
          Swal.fire("Error", res.data.message, "error");
        }
      } catch {
        Swal.fire("Error", "Server error", "error");
      }
    };

    if (!show) return null;

    return (
      <div className="modal fade show d-block">
        <div className="modal-dialog">
          <div className="modal-content">

            <div className="modal-header">
              <h5 className="modal-title">Add Subject</h5>
              <button
                type="button"
                className="btn-close"
                onClick={closeModal}
              ></button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">

                {/* Subject Name */}
                <div className="mb-3">
                  <label>Subject Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subjectName}
                    onChange={(e) => setSubjectName(e.target.value)}
                    required
                  />
                </div>

                {/* Subject Code */}
                <div className="mb-3">
                  <label>Subject Code</label>
                  <input
                    type="text"
                    className="form-control"
                    value={subjectCode}
                    onChange={(e) => setSubjectCode(e.target.value)}
                    required
                  />
                </div>

                {/* Grade Dropdown */}
                <div className="mb-3">
                  <label>Class</label>
                  <select
                    className="form-select"
                    value={gradeId}
                    onChange={(e) => handleGradeChange(e.target.value)}
                    required
                  >
                    <option value="">Select Class</option>
                    {uniqueGrades.map(g => (
                      <option key={g.grade_id} value={g.grade_id}>
                        Class-{g.grade_name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Sections Auto Checked */}
                {gradeId && (
                  <div className="mb-3">
                    <label className="d-block mb-2">
                      Sections (Auto Applied)
                    </label>

                    {sectionsForGrade.map(c => (
                      <div key={c.class_id} className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked
                          disabled
                          readOnly
                        />
                        <label className="form-check-label">
                          Section {c.section_name}
                        </label>
                      </div>
                    ))}
                  </div>
                )}

              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary">
                  Save
                </button>
              </div>

            </form>

          </div>
        </div>
      </div>
    );
  }
);

export default AddSubjectModal;